import { ExtendedBathDaiModel, BathDaiModel } from '@core/models/models/bathe.model';
import { BathDaiRequestModel } from '@core/models/request/bathe-request.model';

export interface Tag {
    label: string;
    type: 'restriction' | 'schedule' | 'info';
}

export interface SidebarBlock {
    daiCd: string; // User ID for filtering and tracking
    name: string;
    gender?: number;
    badge?: string;
    time?: string;
    remind?: string;
    bathDaysOriginal?: string | null; // Original bathDays date string for lastBatheDate
    isRestricted?: boolean;
    tags?: Tag[];
    dateColorClass?: string; // Pre-computed CSS class for date/days text color
}

export interface BatheOption {
    label: string;
    value: string;
}

export interface Holiday {
    holiday: string; // Format: YYYY/MM/DD
    note: string;    // Holiday note, e.g., "祝日"
}

export enum DayColorType {
    Normal = 1,      // Black - regular weekday
    Saturday = 2,    // Blue - Saturday
    OffWork = 3      // Red - Sunday/Holiday
}

export interface WeeklyColumn {
    date: Date;
    dateStr: string; // ISO format YYYY-MM-DD for data lookup
    displayDate: string; // Format: 10/27（日）
    colorType: DayColorType;
    totalUsers: number;
    daiList: ExtendedBathDaiModel[];
    isPastDate: boolean; // True if date is before today
    columnIndex: number; // 0-based index for even/odd styling
    isOverCapacity: boolean; // True if totalUsers exceeds room capacity
    isShow: boolean; // True if column is within visible range
    isSaved?: boolean; // True if this date's data has been saved to BATHDAILY in current session
}

/**
 * Track pending changes for weekly mode auto-save
 * Stores the final position of each item after drag & drop
 */
export interface WeeklyPendingChange {
    daiCd: string;
    originalDateStr: string; // Original date where item started (first drag)
    targetDateStr: string; // Final date where item was dropped
    targetColumn: WeeklyColumn; // Reference to target column
    movedItem: ExtendedBathDaiModel; // The item that was moved
    timestamp: number; // Timestamp of last change for this item
}

/**
 * Request model with metadata for batch operations
 * Used internally within saveBatheDaiDataForTable function
 */
export interface RequestWithMeta {
    request: BathDaiRequestModel;
    hasBathDaily: boolean;
}
